export interface LangGraphSseEvent {
  event: string;
  data: unknown;
}

export async function* parseLangGraphServerSentEvents(
  stream: ReadableStream<Uint8Array>,
): AsyncGenerator<LangGraphSseEvent> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    for (;;) {
      const { done, value } = await reader.read();
      // Normalised once appended: a CRLF can arrive split across two chunks.
      buffer = (buffer + (done ? decoder.decode() : decoder.decode(value, { stream: true })))
        .replaceAll('\r\n', '\n');

      let boundary = buffer.indexOf('\n\n');
      while (boundary !== -1) {
        const block = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        const parsed = parseBlock(block);
        if (parsed) {
          yield parsed;
        }
        boundary = buffer.indexOf('\n\n');
      }

      if (done) {
        const tail = parseBlock(buffer);
        if (tail) {
          yield tail;
        }
        return;
      }
    }
  } finally {
    reader.releaseLock();
  }
}

function parseBlock(block: string): LangGraphSseEvent | null {
  let event = 'message';
  const dataLines: string[] = [];

  for (const line of block.split('\n')) {
    if (line.startsWith('event:')) {
      event = line.slice('event:'.length).trim();
    } else if (line.startsWith('data:')) {
      dataLines.push(line.slice('data:'.length).trimStart());
    }
    // Comment lines (keep-alives) and unknown fields are ignored, per the SSE spec.
  }

  if (dataLines.length === 0) {
    return null;
  }

  const raw = dataLines.join('\n');
  return { event, data: raw.length > 0 ? JSON.parse(raw) : null };
}
